import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { NotificationFeed } from '@mlm/ui';
import { listNotifications, markAllNotificationsRead, markNotificationRead } from '../lib/api';

/** The signed-in admin's own notification feed (owner alerts land here). */
export function NotificationsPage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const q = useInfiniteQuery({
    queryKey: ['notifications', 'list'],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => listNotifications({ limit: 25, cursor: pageParam }),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
  const markAll = useMutation({
    mutationFn: markAllNotificationsRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
  const markOne = useMutation({
    mutationFn: markNotificationRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });

  return (
    <NotificationFeed
      items={q.data?.pages.flatMap((p) => p.items) ?? []}
      isLoading={q.isLoading}
      hasNextPage={!!q.hasNextPage}
      isFetchingNextPage={q.isFetchingNextPage}
      onLoadMore={() => q.fetchNextPage()}
      onMarkRead={(id) => markOne.mutate(id)}
      onMarkAll={() => markAll.mutate()}
      markAllPending={markAll.isPending}
      onOpen={(path) => navigate(path)}
      formatDate={(iso) => new Date(iso).toLocaleString()}
    />
  );
}
